import { Icon, Td, Tr, useDisclosure } from '@chakra-ui/react'
import Description from '../../../../components/Icon/Description'
import colors from '../../../../config/theme/colors'
import ModalHistories from '../../modals/ModalHistories'
import { TableRowProps } from './types'
import TdStock from './TdStock'

export default function TableRow({
    item,
    startDate,
    endDate,
    reload
}: TableRowProps) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    // Determinar si el artículo está por debajo del stock mínimo
    const hasMinQuantity = item.min_quantity > 0
    const isCritical = hasMinQuantity && item.stock < item.min_quantity
    const isLow =
        hasMinQuantity &&
        item.stock >= item.min_quantity &&
        item.stock <= item.min_quantity * 1.2

    // Determinar el estado del stock
    const getStockStatus = (): 'critical' | 'low' | 'normal' => {
        if (isCritical) return 'critical'
        if (isLow) return 'low'
        return 'normal'
    }

    return (
        <Tr>
            <Td>{item.production_item.name}</Td>
            <Td>{item.warehouse.name}</Td>
            <TdStock
                reload={reload}
                item={item}
                stock={item.stock}
                status={getStockStatus()}
            />
            <Td>{item.min_quantity}</Td>
            <Td>{item.production_item?.magnitude?.name}</Td>
            <Td>{item.cost ?? '-'}</Td>
            <Td>
                {item.cost
                    ? Math.round(item.cost * item.stock * 100) / 100
                    : '-'}
            </Td>
            <Td>
                <ModalHistories
                    isOpen={isOpen}
                    onClose={onClose}
                    initialStartDate={startDate}
                    inititalEndDate={endDate}
                    item={item}
                />
                <Icon
                    onClick={onOpen}
                    fill={colors['alo-blue']}
                    as={Description}
                    marginRight={2}
                    cursor="pointer"
                />
            </Td>
        </Tr>
    )
}
